
if (!window.Eurus.loadedScript.has('estimate-shipping-rate.js')) {
  window.Eurus.loadedScript.add('estimate-shipping-rate.js');
  
  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      const getSavedDeliveryLocation = (storageKey) => {
        if (!storageKey) return null;

        try {
          return JSON.parse(localStorage.getItem(storageKey) || '{}');
        } catch (error) {
          return null;
        }
      };

      Alpine.store('xCartShippingEstimate', {
        loading: false,
        rate: null,
        message: '',
        // tl: full rate list + the address it was fetched for, so the cart-drawer
        // "Estimate shipping" block (cart-total-summary.liquid) can render selectable
        // rate cards. pickRate() re-uses setRate so the summary rows react as usual.
        rates: [],
        ratesAddress: null,
        pickRate(rate) {
          this.setRate(rate, this.ratesAddress);
        },
        setLoading(value) {
          this.loading = value;
        },
        setRate(rate, address) {
          if (!rate) {
            this.rate = null;
            this.message = '';
            return;
          }

          this.rate = {
            name: rate.name,
            price: rate.price,
            currency: rate.currency,
            priceCents: Math.round(Number.parseFloat(rate.price || 0) * 100),
            priceText: `${rate.price} ${rate.currency}`,
            // tl: rate description carries the delivery estimate set on the shipping zone
            description: rate.description || '',
            address
          };
          this.message = '';
        },
        setMessage(message) {
          this.rate = null;
          this.rates = [];
          this.ratesAddress = null;
          this.message = message || '';
        }
      });

      Alpine.data("xEstimateShipping", (el, single, multiple, noRates) => ({
        countryEl: el.querySelector('.country-select'),
        provinceEl: el.querySelector('.province-select'),
        provinceContainer: el.querySelector('.province-container'),
        zip: el.querySelector('.zip-input'),
        rates: el.querySelector('.rates'),
        errors: el.querySelector('.errors'),
        loadingShipping: false,
        rates_heading: '',
        rates_text: '',
        errors_message: '',
        savedDeliveryLocation: null,
        cachedData: [],
        cachedResponse:[],
        load() {
          this.setSelectedOption(this.countryEl, this.countryEl.dataset.default);
    
          this.handleCountryChange();
          this.applySavedDeliveryLocation();

          if (!this.savedDeliveryLocation?.zip && this.provinceEl.dataset.default && this.provinceEl.options.length > 0) {
            this.setSelectedOption(this.provinceEl, this.provinceEl.dataset.default);
          }

          this.countryEl.addEventListener('change', this.handleCountryChange.bind(this));
        },
        
        handleCountryChange() {
          const selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
          const provinces = JSON.parse(selectedOption.dataset.provinces);
    
          Array.from(this.provinceEl.options).forEach((option) => option.remove());
    
          if (provinces && provinces.length === 0) {
            this.provinceContainer.hidden = true;
          } else {
            provinces.forEach((province) => {
              const option = document.createElement('option');
              [option.value, option.innerHTML] = province;
              this.provinceEl.appendChild(option);
            });
    
            this.provinceContainer.hidden = false;
          }
        },

        applySavedDeliveryLocation() {
          const saved = getSavedDeliveryLocation(el.dataset.deliveryLocationStorageKey);
          this.savedDeliveryLocation = saved;
          if (!saved || !this.zip) return;

          const currentCountryIso = el.dataset.currentCountryIso;
          if (saved.zip && (!saved.countryIso || saved.countryIso === currentCountryIso)) {
            this.zip.value = saved.zip;
            this.provinceEl.value = '';
          }
        },

        // tl: the drawer estimator has no ZIP field (shipping profiles are
        // country-level, so a ZIP never changes the quoted rate), but Shopify's
        // /cart/shipping_rates.json still REQUIRES a syntactically valid postal
        // code for many countries (US/DE/GB… return 422 "Enter a ZIP code"),
        // and for provinced countries (US/CA/AU…) it cross-validates the ZIP
        // against the selected province. So each sample is a matching
        // province+ZIP pair; any in-country address yields the same
        // country-level rate.
        sampleAddress(country) {
          const map = {
            'United States': { zip: '10001', province: 'New York' },
            'Canada': { zip: 'M5H 2N2', province: 'Ontario' },
            'Australia': { zip: '2000', province: 'New South Wales' },
            'United Kingdom': { zip: 'SW1A 1AA' },
            'Germany': { zip: '10115' },
            'France': { zip: '75001' },
            'Turkey': { zip: '34000' },
            'Türkiye': { zip: '34000' },
            'Netherlands': { zip: '1011 AB' },
            'Italy': { zip: '00100', province: 'Roma' },
            'Spain': { zip: '28001', province: 'Madrid' },
            'Austria': { zip: '1010' },
            'Belgium': { zip: '1000' },
            'Switzerland': { zip: '8001' },
            'Sweden': { zip: '111 20' },
            'Norway': { zip: '0010' },
            'Denmark': { zip: '1050' },
            'Ireland': { zip: 'D01 F5P2', province: 'Dublin' },
            'Portugal': { zip: '1000-001', province: 'Lisbon' },
            'Poland': { zip: '00-001' },
            'Finland': { zip: '00100' },
            'Czechia': { zip: '110 00' },
            'Greece': { zip: '105 57' },
            'Hungary': { zip: '1011' },
            'Romania': { zip: '010011', province: 'București' },
            'Japan': { zip: '100-0001', province: 'Tōkyō' },
            'South Korea': { zip: '04524', province: 'Seoul' },
            'New Zealand': { zip: '6011', province: 'Wellington' },
            'Mexico': { zip: '01000', province: 'Ciudad de México' },
            'Brazil': { zip: '01000-000', province: 'São Paulo' },
            'Israel': { zip: '9100000' },
            'Saudi Arabia': { zip: '11564' },
            'Singapore': { zip: '018956' },
            'India': { zip: '110001', province: 'Delhi' },
            'Thailand': { zip: '10200', province: 'Bangkok' },
            'Malta': { zip: 'VLT 1000' },
            'Iceland': { zip: '101' },
            'Russia': { zip: '101000', province: 'Moscow' },
            'China': { zip: '100000', province: 'Beijing' }
          };
          return map[country] || { zip: '' };
        },

        setSelectedOption(selector, value) {
          Array.from(selector.options).forEach((option, index) => {
            if (option.value === value || option.innerHTML === value) {
              selector.selectedIndex = index;
            }
          });
        },

        async resolveProvinceFromZip() {
          const country = this.countryEl.value;
          const zip = (this.zip?.value || '').replace(/\D/g, '').slice(0, 5);

          if (country !== 'United States' || !zip || this.provinceEl.value) return;

          try {
            const response = await fetch(`https://api.zippopotam.us/us/${zip}`, { method: 'GET' });
            if (!response.ok) return;

            const data = await response.json();
            const provinceCode = data.places?.[0]?.['state abbreviation'];
            const provinceName = data.places?.[0]?.state;
            if (!provinceCode && !provinceName) return;

            this.setSelectedOption(this.provinceEl, provinceCode);
            if (!this.provinceEl.value && provinceName) {
              this.setSelectedOption(this.provinceEl, provinceName);
            }
          } catch (error) {
            console.log(error);
          }
        },

        async submit(e) {

          e?.preventDefault();

          this.errors.classList.add('hidden');
          this.rates.classList.add('hidden');

          await this.resolveProvinceFromZip();

          // tl: no ZIP input in the drawer — substitute a representative in-country
          // address (see sampleAddress) so Shopify's mandatory-ZIP validation passes.
          // An EMPTY zip field falls back the same way, so the silent auto-calculate
          // on the cart page resolves a country-level rate instead of a 422 error.
          let zipValue = '';
          const typedZip = !!(this.zip && this.zip.value.trim() !== '');
          if (typedZip) {
            zipValue = this.zip.value;
          } else {
            const sample = this.sampleAddress(this.countryEl.value);
            zipValue = sample.zip;
            if (sample.province) this.setSelectedOption(this.provinceEl, sample.province);
          }
          const params = `shipping_address[zip]=${encodeURIComponent(zipValue)}&shipping_address[country]=${this.countryEl.value}&shipping_address[province]=${this.provinceEl.value}`;
    
          if (this.cachedData[params]) {
            if ( this.cachedResponse[params]) {
              this.showRates(this.cachedData[params]);
            } else {
              this.showErrors(this.cachedData[params]);
            }
            return true;
          }

          this.loadingShipping = true;
          Alpine.store('xCartShippingEstimate')?.setLoading(true);
          try {
            let response = await fetch(`${Shopify.routes.root}cart/shipping_rates.json?${params}`);
            let data = await response.json();

            // tl: countries missing from sampleAddress still need a format-valid
            // postal code (Ukraine, Lithuania, Croatia… return 422 "Enter a postal
            // code"). When the shopper typed no ZIP, cycle generic codes that cover
            // the common 4/5/6-digit formats until Shopify stops rejecting the zip.
            if (!response.ok && data?.zip && !typedZip) {
              const country = encodeURIComponent(this.countryEl.value);
              const province = encodeURIComponent(this.provinceEl.value);
              for (const candidate of ['10000', '1000', '100000', '01001', '000000']) {
                if (candidate === zipValue) continue;
                const retry = await fetch(`${Shopify.routes.root}cart/shipping_rates.json?shipping_address[zip]=${candidate}&shipping_address[country]=${country}&shipping_address[province]=${province}`);
                const retryData = await retry.json();
                if (retry.ok || !retryData?.zip) {
                  response = retry;
                  data = retryData;
                  break;
                }
              }
            }

            // tl: the US has a separate "US Military (APO/FPO/DPO)" zone (AA/AE/AP
            // states, different carrier + transit time). The sample address above is
            // New York, so its rates never come back — fetch them with a sample APO
            // address and append them, flagged tlMilitary for the rate-card label.
            // Skipped when the shopper typed a real ZIP (that ZIP decides the zone).
            if (response.ok && zipValue !== this.zip?.value && this.countryEl.value === 'United States') {
              try {
                const milParams = `shipping_address[zip]=09001&shipping_address[country]=United%20States&shipping_address[province]=AE`;
                const milResponse = await fetch(`${Shopify.routes.root}cart/shipping_rates.json?${milParams}`);
                const milData = milResponse.ok ? await milResponse.json() : null;
                (milData?.shipping_rates || []).forEach((rate) => {
                  if (!data.shipping_rates.some((r) => r.name === rate.name)) {
                    data.shipping_rates.push({ ...rate, tlMilitary: true });
                  }
                });
              } catch (error) {
                console.log(error);
              }
            }

            if (response.ok) {
              this.showRates(data);
            } else {
              this.showErrors(data);
            }
            this.cachedResponse[params] = response.ok;
            this.cachedData[params] = data;
          } catch (error) {
            console.log(error); 
            Alpine.store('xCartShippingEstimate')?.setMessage(noRates);
          } finally {
            this.loadingShipping= false;
            Alpine.store('xCartShippingEstimate')?.setLoading(false);
          }
        },
    
        showRates(data) {
          const headingEl = this.rates.querySelector('.rates-heading');
    
          if (data.shipping_rates && data.shipping_rates.length) {
            // tl: rate names carry "(Duty Unpaid)" from admin. When the market includes
            // duties in product prices (cart.duties_included, passed via data attribute),
            // show "Duty Paid" instead; otherwise force "Duty Unpaid".
            const dutiesFlag = el.dataset.tlDutiesIncluded;
            if (dutiesFlag === 'true' || dutiesFlag === 'false') {
              const dutyLabel = dutiesFlag === 'true' ? 'Duty Paid' : 'Duty Unpaid';
              data.shipping_rates = data.shipping_rates.map((rate) => ({
                ...rate,
                name: (rate.name || '').replace(/dut(y|ies)[\s-]*(un)?paid/i, dutyLabel)
              }));
            }
            this.rates_heading = data.shipping_rates.length === 1 ? single : multiple;
            let rates = '';
            
            data.shipping_rates.forEach((rate) => {
              const formattedRate = `${rate.price} ${rate.currency}`;
              rates += `<li class="pt-2">${rate.name}${rate.tlMilitary ? ' (APO/FPO/DPO)' : ''}: ${formattedRate}</li>`;
            });

            const estimateStore = Alpine.store('xCartShippingEstimate');
            const estimateAddress = {
              country: this.countryEl.value,
              province: this.provinceEl.value,
              zip: this.zip ? this.zip.value : this.sampleAddress(this.countryEl.value).zip
            };
            if (estimateStore) {
              estimateStore.rates = data.shipping_rates;
              estimateStore.ratesAddress = estimateAddress;
            }
            estimateStore?.setRate(data.shipping_rates[0], estimateAddress);
    
            headingEl.classList.remove('hidden');
            this.rates_text = `<ul class="list-disc pl-4">${rates}</ul>`;
          } else {
            headingEl.classList.add('hidden');
            this.rates_text = `<p class="no-rate">${noRates}</p>`;
            Alpine.store('xCartShippingEstimate')?.setMessage(noRates);
          }
    
          this.rates.classList.remove('hidden');
        },
    
        showErrors(data) {
          let errors = '';
          let errorsText = '';
          Object.keys(data).forEach((key) => {
            errors += `<li>${data[key]}</li>`;
            errorsText += `${data[key]} `;
          });
    
          this.errors_message = `<ul>${errors}</ul>`;
          Alpine.store('xCartShippingEstimate')?.setMessage(errorsText.trim() || noRates);
          this.errors.classList.remove('hidden');
        }
      }));
      Alpine.store('xPopupShipping', {
        open: false
      });
    });
  });
}
